import React from 'react'
import { Outlet } from 'react-router-dom'
import { motion } from 'framer-motion'
import { Sidebar } from './sidebar'
import { MobileNav } from './mobile-nav'
import { useChurchColors } from '@/hooks/useChurchColors'

const MainLayoutComponent = React.memo(() => {
  // Aplicar cores da igreja globalmente
  useChurchColors()

  return (
    <div className="relative min-h-screen bg-gradient-to-br from-background via-background to-muted/10">
      {/* Desktop Sidebar */}
      <aside className="fixed inset-y-0 left-0 z-50 hidden w-64 border-r shadow-sm lg:block">
        <Sidebar />
      </aside>

      {/* Main Content */}
      <main className="min-h-screen pb-24 lg:ml-64 lg:pb-8">
        <div className="px-4 py-6 sm:px-6 lg:px-8 lg:py-8 xl:px-12">
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
          >
            <Outlet />
          </motion.div>
        </div>
      </main>

      {/* Mobile Bottom Navigation */}
      <div className="fixed inset-x-0 bottom-0 z-50 lg:hidden">
        <MobileNav />
      </div>
    </div>
  )
})

MainLayoutComponent.displayName = 'MainLayout'

export const MainLayout = MainLayoutComponent
